import { useOSDetection } from '../../hooks/useOSDetection';
import { useShortcut } from '../../hooks/useShortcut';
import { IButton } from './interfaces';
import styles from './styles.module.css';

const Button = ({
	label,
	variant = 'primary',
	onClick,
	icon,
	customStyles,
	id,
	disabled = false,
	isLoading = false,
	executeShortcut = () => {},
	shortcut,
}: IButton) => {
	useShortcut(executeShortcut, shortcut);
	const os = useOSDetection();

	let variantClass = styles.btnPrimary;
	if (id === 'btn-aceptar') variantClass = styles.btnIdAceptar;

	switch (variant) {
		case 'secondary':
			variantClass = styles.btnSecondary;
			break;
		case 'success':
			variantClass = styles.btnSuccess;
			break;
		case 'error':
			variantClass = styles.btnError;
			break;
		case 'info':
			variantClass = styles.btnInfo;
			break;
		case 'warning':
			variantClass = styles.btnWarning;
			break;
		case 'custom':
			variantClass = styles.btnCustom;
			break;
	}

	const baseClasses = `${styles.btn} ${variantClass}`;
	const disabledClasses = `${styles.btn} ${styles.btnDisabled}`;
	const buttonClasses = disabled ? disabledClasses : baseClasses;

	return (
		<button
			disabled={disabled}
			id={id}
			onClick={onClick}
			className={`${buttonClasses} ${icon ? styles.btnIcon : ''} ${customStyles} ${
				isLoading ? styles.btnLoading : ''
			}`}
		>
			<div className={styles.btnContent}>
				{isLoading ? (
					<>
						Cargando...
						<div className={styles.spinner} />
					</>
				) : (
					<>
						{icon && <span>{icon}</span>}
						{label}
						{shortcut && (
							<div className={styles.shortcut}>
								<span className={styles.key}>
									{os === 'MacOS' ? '⌘' : 'Ctrl'}
								</span>
								<span className={styles.key}>
									{shortcut.toUpperCase()}
								</span>
							</div>
						)}
					</>
				)}
			</div>
		</button>
	);
};

export default Button;
